'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { type FC, useEffect } from 'react'

type StoryblokGlossaryPageGtmProps = {
  event: object
}

export const StoryblokGlossaryPageGtm: FC<StoryblokGlossaryPageGtmProps> = ({
  event,
}) => {
  useEffect(() => {
    sendGTMEvent(event)
  }, [event])

  return null
}
